import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Briefcase, ArrowRight } from "lucide-react";

export default function AdminProjects() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/projects/").then(r => setItems(r.data || [])).catch(() => {}); }, []);
  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-1">Progetti</h1>
      <p className="text-sm text-slate-600 mb-6">Tutti i progetti attivati nella piattaforma.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(p => (
          <Link to={`/admin/projects/${p.id}`} key={p.id}>
            <div className="cxo-card p-5 h-full">
              <Badge className={`border-0 ${p.status === "active" ? "bg-[#E9F8F1] text-[#1F9D6A]" : "bg-slate-100 text-slate-700"}`}>{p.status}</Badge>
              <h3 className="mt-3 font-semibold text-slate-900">{p.title}</h3>
              <p className="text-xs text-slate-500">{p.company?.company_name}</p>
              <p className="text-xs text-slate-500">Manager: {p.manager?.user?.full_name}</p>
              <p className="text-xs text-slate-500">Pacchetto: {p.package}</p>
              <div className="mt-3 text-sm font-semibold text-[#2D6BFF] inline-flex items-center">Apri <ArrowRight size={14} className="ml-1" /></div>
            </div>
          </Link>
        ))}
        {!items.length && <div className="cxo-card p-10 text-center text-slate-500 col-span-full">Nessun progetto</div>}
      </div>
    </div>
  );
}
